import { render, staticRenderFns } from "./propertyTenureListing.vue?vue&type=template&id=e1661b14&"
import script from "./propertyTenureListing.vue?vue&type=script&lang=js&"
export * from "./propertyTenureListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports